/**
 * @desc 自动化流程引擎
 * @author caojianbo
 * @date 2024年04月08日09:32:12
 */
export default {
  流程名字: '流程名字',
  请输入流程名字: '请输入流程名字',
  触发动作: '触发动作',
  请选择: '请选择',
  运行状态: '运行状态',
  启用状态: '启用状态',
  开启: '开启',
  执行动作: '执行动作',
  输入LP主体名称: '输入LP主体名称',
  请编辑流程名字: '请编辑流程名字',
  请选择触发动作: '请选择触发动作',
  请选择记录所在对象: '请选择记录所在对象',
  如果同时满足指定条件: '如果同时满足指定条件',
  编辑流程引擎: '编辑流程引擎',
  标题背景色: '标题背景色',
  标题: '标题',
  '请填写标题(最多150个字符)': '请填写标题(最多150个字符)',
  '请填写消息内容(最多3000个字符)': '请填写消息内容(最多3000个字符)',
  当: '当',
  时: '时',
  就在: '就在',
  中: '中',
  第: '第',
  步: '步',
  命名: '命名',
  日志: '日志',
  复制: '复制',
  删除: '删除',
  内容: '内容',
  昨天: '昨天',
  今天: '今天',
  明天: '明天',
  取消: '取消',
  仅保存: '仅保存',
  保存并启用: '保存并启用',
  然后执行另外: '然后执行另外',
  执行操作的时间: '执行操作的时间',
  发送飞书消息: '发送飞书消息',
  流程名称: '流程名称',
  自动化流程引擎: '自动化流程引擎',
  流程名称不能超过100个字: '流程名称不能超过100个字',
  流程名称不能为空: '流程名称不能为空',
  删除当前步骤: '删除当前步骤',
  '删除后，将无法回复该步骤，确认删除吗？': '删除后，将无法回复该步骤，确认删除吗？',
  自然时间: '自然时间',
  选择之前步骤产生的数据: '选择之前步骤产生的数据',
  查找的记录: '查找的记录',
  新增的记录: '新增的记录',
  修改的记录: '修改的记录',
  满足条件的记录: '满足条件的记录',
  '当前页面尚未保存，是否确认关闭？': '当前页面尚未保存，是否确认关闭？',
  温馨提示: '温馨提示',
  确认关闭: '确认关闭',
  获取数据失败: '获取数据失败',
  自动化流程: '自动化流程',
  个操作: '个操作',
  请选择记录: '请选择记录',
  选择记录所在对象: '选择记录所在对象',
  选择记录: '选择记录',
  设置查找内容: '设置查找内容',
  请选择要设置的查找内容: '请选择要设置的查找内容',
  '新增与修改记录的内容满足条件时将会触发此条件，已有的记录内容满足条件时并不会触发': '新增与修改记录的内容满足条件时将会触发此条件，已有的记录内容满足条件时并不会触发',
  添加同时满足的条件: '添加同时满足的条件',
  就执行以下操作: '就执行以下操作',
  向上插入一个操作: '向上插入一个操作',
  向下插入一个操作: '向下插入一个操作',
  复制操作: '复制操作',
  删除操作: '删除操作',
  全部记录: '全部记录',
  指定记录: '指定记录',
  当以下情况发生时: '当以下情况发生时',
  添加操作: '添加操作',
  新建流程引擎: '新建流程引擎',
  添加底部按钮: '添加底部按钮',
  '添加后，可通过底部按钮跳转到指定链接或执行新增/修改记录': '添加后，可通过底部按钮跳转到指定链接或执行新增/修改记录',
  默认样式: '默认样式',
  强调样式: '强调样式',
  警示样式: '警示样式',
  跳转链接: '跳转链接',
  按钮: '按钮',
  配置: '配置',
  按钮文字: '按钮文字',
  按钮样式: '按钮样式',
  点击按钮时: '点击按钮时',
  链接地址: '链接地址',
  '必填,按钮上只展示25个字符': '必填,按钮上只展示25个字符',
  请填写链接地址: '请填写链接地址',
  添加按钮: '添加按钮',
  '删除后，将无法恢复步骤，确认删除吗？': '删除后，将无法恢复步骤，确认删除吗？',
  请选择群组: '请选择群组',
  请添加接收人或群组: '请添加接收人或群组',
  组织架构人员: '组织架构人员',
  租户群组: '租户群组',
  输入关键字进行搜索: '输入关键字进行搜索',
  第一步新增的记录: '第一步新增的记录',
  第一步满足条件的的记录: '第一步满足条件的的记录',
  所有: '所有',
  任一: '任一',
  设置筛选条件: '设置筛选条件',
  筛选该操作执行时符合条件的记录: '筛选该操作执行时符合条件的记录',
  符合以下: '符合以下',
  筛选条件: '筛选条件',
  未查找到记录时: '未查找到记录时',
  继续执行: '继续执行',
  终止流程: '终止流程',
  设置触发值: '设置触发值',
  第一步修改的的记录: '第一步修改的的记录',
  设置满足的条件: '设置满足的条件',
  关注以下任一字段变更: '关注以下任一字段变更',
  可输入字段名称进行搜索: '可输入字段名称进行搜索',
  取消选择: '取消选择',
  修改记录后同时满足以下条件: '修改记录后同时满足以下条件',
  新记录被添加时同时满足以下条件: '新记录被添加时同时满足以下条件',
  级: '级',
  记录: '记录',
  本人上级: '本人上级',
  本人: '本人',
  运行耗时: '运行耗时',
  运行日志: '运行日志',
  从以下步骤中选择: '从以下步骤中选择',
  选择目标对象: '选择目标对象',
  请选择目标对象: '请选择目标对象',
  字段映射配置: '字段映射配置',
  当此对象开启了飞书审批时: '当此对象开启了飞书审批时',
  新增记录: '新增记录',
  记录内容变更: '记录内容变更',
  '新增/修改的记录满足条件': '新增/修改的记录满足条件',
  定时触发: '定时触发',
  修改记录: '修改记录',
  AI生成内容: 'AI生成内容',
  查找记录: '查找记录',
  循环新增记录: '循环新增记录',
  循环修改记录: '循环修改记录',
  依次处理每条记录: '依次处理每条记录',
  循环方式: '循环方式',
  需要循环处理的记录: '需要循环处理的记录',
  请选择循环方式: '请选择循环方式',
  目标记录: '目标记录',
  请选择目标记录: '请选择目标记录',
  开启触发飞书审批: '开启触发飞书审批',
  直接发起审批: '直接发起审批',
  无需发起审批: '无需发起审批',
  '仅保存，完善后发起审批': '仅保存，完善后发起审批',
  第1步新增的记录: '第1步新增的记录',
  第1步满足条件的的记录: '第1步满足条件的的记录',
  第1步修改的的记录: '第1步修改的的记录',
  日志产生时间: '日志产生时间',
  操作日志: '操作日志',
  触发时间: '触发时间',
  操作人: '操作人',
  执行结果: '执行结果',
  请选择运行状态: '请选择运行状态',
  请选择操作人: '请选择操作人',
  记录名称: '记录名称',
  执行详情: '执行详情',
  操作时间: '操作时间',
  变更为: '变更为',
  销售线索: '销售线索',
  客户: '客户',
  商机: '商机',
  产品: '产品',
  报价单: '报价单',
  '报价单-产品': '报价单-产品',
  合同: '合同',
  '合同-产品': '合同-产品',
  销售订单: '销售订单',
  '销售订单-产品': '销售订单-产品',
  售后服务单: '售后服务单',
  退货单: '退货单',
  '退货单-产品': '退货单-产品',
  '商机云文档/附件': '商机云文档/附件',
  '商机-产品': '商机-产品',
  动态记录: '动态记录',
  线索池: '线索池',
  富文本: '富文本',
  子表单: '子表单',
  秒级: '秒级',
  毫秒级: '毫秒级',
  关联审批: '关联审批',
  单选: '单选',
  多选: '多选',
  映射至飞书审批: '映射至飞书审批',
  预置按钮: '预置按钮'
};
